/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EvalSuiteManifest,
  EvalSuiteManifest$inboundSchema,
  EvalSuiteManifest$Outbound,
  EvalSuiteManifest$outboundSchema,
} from "./evalsuitemanifest.js";

export type CreateEvalSuiteVersionRequest = {
  manifest: EvalSuiteManifest;
  metadata?: { [k: string]: string } | undefined;
  makeActive?: boolean | undefined;
};

/** @internal */
export const CreateEvalSuiteVersionRequest$inboundSchema: z.ZodType<
  CreateEvalSuiteVersionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  manifest: EvalSuiteManifest$inboundSchema,
  metadata: z.record(z.string()).optional(),
  make_active: z.boolean().default(true),
}).transform((v) => {
  return remap$(v, {
    "make_active": "makeActive",
  });
});
/** @internal */
export type CreateEvalSuiteVersionRequest$Outbound = {
  manifest: EvalSuiteManifest$Outbound;
  metadata?: { [k: string]: string } | undefined;
  make_active: boolean;
};

/** @internal */
export const CreateEvalSuiteVersionRequest$outboundSchema: z.ZodType<
  CreateEvalSuiteVersionRequest$Outbound,
  z.ZodTypeDef,
  CreateEvalSuiteVersionRequest
> = z.object({
  manifest: EvalSuiteManifest$outboundSchema,
  metadata: z.record(z.string()).optional(),
  makeActive: z.boolean().default(true),
}).transform((v) => {
  return remap$(v, {
    makeActive: "make_active",
  });
});

export function createEvalSuiteVersionRequestToJSON(
  createEvalSuiteVersionRequest: CreateEvalSuiteVersionRequest,
): string {
  return JSON.stringify(
    CreateEvalSuiteVersionRequest$outboundSchema.parse(
      createEvalSuiteVersionRequest,
    ),
  );
}
export function createEvalSuiteVersionRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateEvalSuiteVersionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateEvalSuiteVersionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateEvalSuiteVersionRequest' from JSON`,
  );
}
